// Date 2020-10-10 11:23:48

import sithMesPrdPpHeader from "@/store/sithMes/prd/SithMesPrdPpHeaderStore.js";
import sithMesPrdPpOperation from "@/store/sithMes/prd/SithMesPrdPpOperationStore.js";
import sithMesPrdPpStatus from "@/store/sithMes/prd/SithMesPrdPpStatusStore.js";
import sithMesPrdPpStatusUpdateLog from "@/store/sithMes/prd/SithMesPrdPpStatusUpdateLogStore.js";
import sithMesPrdRoutingSummary from "@/store/sithMes/prd/SithMesPrdRoutingSummaryStore.js";
import sithMesPrdRoutingSummaryDetail from "@/store/sithMes/prd/SithMesPrdRoutingSummaryDetailStore.js";
import sithMesPrdShiftHandover from "@/store/sithMes/prd/SithMesPrdShiftHandoverStore.js";
import sithMesPrdStopWorkType from "@/store/sithMes/prd/SithMesPrdStopWorkTypeStore.js";
import sithMesPrdWorkHourRecord from "@/store/sithMes/prd/SithMesPrdWorkHourRecordStore.js";
import sithMesPrdEhs from "@/store/sithMes/prd/SithMesPrdEhsStore.js";
import sithMesPrdOperationUser from "@/store/sithMes/prd/SithMesPrdOperationUserStore.js";
import sithMesPrdProjectInfo from "@/store/sithMes/prd/SithMesPrdProjectInfoStore.js";
import sithMesPrdPpOperationSchedulePos from "@/store/sithMes/prd/SithMesPrdPpOperationSchedulePosStore.js";
import sithMesPrdPpOperationDependencyPod from "@/store/sithMes/prd/SithMesPrdPpOperationDependencyPodStore.js";
import sithMesPrdFaultRecord from "@/store/sithMes/prd/SithMesPrdFaultRecordStore.js";
import sithMesPrdPpScheduledResultPsr from "@/store/sithMes/prd/SithMesPrdPpScheduledResultPsrStore.js";
import sithMesPrdLearning from "@/store/sithMes/prd/SithMesPrdLearningStore.js";
import sithMesPrdOperationStorage from "@/store/sithMes/prd/SithMesPrdOperationStorageStore.js";
import sithMesPrdProjectPlanPrp from "@/store/sithMes/prd/SithMesPrdProjectPlanPrpStore.js";
import sithMesPrdProjectPlanDetailPpd from "@/store/sithMes/prd/SithMesPrdProjectPlanDetailPpdStore.js";
import sithMesProProjectPlanDetailDepPpdd from "@/store/sithMes/prd/SithMesProProjectPlanDetailDepPpddStore.js";
import sithMesPrdPdsrRPrpPdrp from "@/store/sithMes/prd/SithMesPrdPdsrRPrpPdrpStore.js";
import sithMesPrdManBorrowProcess from "@/store/sithMes/prd/SithMesPrdManBorrowProcessStore.js";
import sithMesPrdPpHeaderInfoModifyType from "@/store/sithMes/prd/SithMesPrdPpHeaderInfoModifyTypeStore.js";
import sithMesPrdPpHeaderInfoModify from "@/store/sithMes/prd/SithMesPrdPpHeaderInfoModifyStore.js";
import sithMesPrdSdProject from "@/store/sithMes/prd/SithMesPrdSdProjectStore.js";
import sithMesPrdSdProjectActivity from "@/store/sithMes/prd/SithMesPrdSdProjectActivityStore.js";
import sithMesPrdSdProjectNetwork from "@/store/sithMes/prd/SithMesPrdSdProjectNetworkStore.js";
import sithMesPrdSdProjectWbs from "@/store/sithMes/prd/SithMesPrdSdProjectWbsStore.js";
import sithMesPrdSdProjectWbsHrc from "@/store/sithMes/prd/SithMesPrdSdProjectWbsHrcStore.js";
import sithMesPrdPpNetwork from "@/store/sithMes/prd/SithMesPrdPpNetworkStore.js";
import sithMesPrdPpComponent from "@/store/sithMes/prd/SithMesPrdPpComponentStore.js";
import sithMesSapHandleRecord from "@/store/sithMes/prd/SithMesSapHandleRecordStore.js";
import sithMesPrdPpHeaderInfoModifyOwner from "@/store/sithMes/prd/SithMesPrdPpHeaderInfoModifyOwnerStore.js";
import sithMesPrdPpdScheduledResultItemPsri from "@/store/sithMes/prd/SithMesPrdPpdScheduledResultItemPsriStore.js";
import sithMesPrdToolsInfo from "@/store/sithMes/prd/SithMesPrdToolsInfoStore.js";
import sithMesPrdToolsPackage from "@/store/sithMes/prd/SithMesPrdToolsPackageStore.js";
import sithMesPrdToolsPackageItem from "@/store/sithMes/prd/SithMesPrdToolsPackageItemStore.js";
import sithMesPrdToolsRelateOperation from "@/store/sithMes/prd/SithMesPrdToolsRelateOperationStore.js";
import sithMesPrdProjectKam from "@/store/sithMes/prd/SithMesPrdProjectKamStore.js";
import sithMesPrdRoutingMaintain from "@/store/sithMes/prd/SithMesPrdRoutingMaintainStore.js";
import sithMesPrdKamChange from "@/store/sithMes/prd/SithMesPrdKamChangeStore.js";
import sithMesPrdInfoRecord from "@/store/sithMes/prd/SithMesPrdInfoRecordStore";
import sithMesPrdProjectProfitCenter from "@/store/sithMes/prd/SithMesPrdProjectProfitCenterStore.js";
import sithMesPrdZpp1 from "@/store/sithMes/prd/SithMesPrdZpp1Store";
import sithMesPrdZpp2 from "@/store/sithMes/prd/SithMesPrdZpp2Store";
import sithMesPrdZpp2MaterialsDetail from "@/store/sithMes/prd/SithMesPrdZpp2MaterialsDetailStore";

const genericEntities = [
    'sithMesPrdPpHeader',
    'sithMesPrdPpOperation',
    'sithMesPrdPpStatus',
    'sithMesPrdPpStatusUpdateLog',
    'sithMesPrdRoutingSummary',
    'sithMesPrdRoutingSummaryDetail',
    'sithMesPrdShiftHandover',
    'sithMesPrdStopWorkType',
    'sithMesPrdWorkHourRecord',
    'sithMesPrdEhs',
    'sithMesPrdOperationUser',
    'sithMesPrdProjectInfo',
    'sithMesPrdPpOperationSchedulePos',
    'sithMesPrdPpOperationDependencyPod',
    'sithMesPrdFaultRecord',
    'sithMesPrdPpScheduledResultPsr',
    'sithMesPrdLearning',
    'sithMesPrdOperationStorage',
    'sithMesPrdProjectPlanPrp',
    'sithMesPrdProjectPlanDetailPpd',
    'sithMesProProjectPlanDetailDepPpdd',
    'sithMesPrdPdsrRPrpPdrp',
    'sithMesPrdManBorrowProcess',
    'sithMesPrdPpHeaderInfoModifyType',
    'sithMesPrdPpHeaderInfoModify',
    'sithMesPrdSdProject',
    'sithMesPrdSdProjectActivity',
    'sithMesPrdSdProjectNetwork',
    'sithMesPrdSdProjectWbs',
    'sithMesPrdSdProjectWbsHrc',
    'sithMesPrdPpNetwork',
    'sithMesPrdPpComponent',
    'sithMesSapHandleRecord',
    'sithMesPrdPpHeaderInfoModifyOwner',
    'sithMesPrdPpdScheduledResultItemPsri',
    'sithMesPrdToolsInfo',
    'sithMesPrdToolsPackage',
    'sithMesPrdToolsPackageItem',
    'sithMesPrdToolsRelateOperation',
    'sithMesPrdProjectKam',
    'sithMesPrdRoutingMaintain',
    'sithMesPrdKamChange',
    'sithMesPrdInfoRecord',
    'sithMesPrdProjectProfitCenter',
    'sithMesPrdZpp1',
    'sithMesPrdZpp2',
    'sithMesPrdZpp2MaterialsDetail'
]

const entities = {
    sithMesPrdPpHeader,
    sithMesPrdPpOperation,
    sithMesPrdPpStatus,
    sithMesPrdPpStatusUpdateLog,
    sithMesPrdRoutingSummary,
    sithMesPrdRoutingSummaryDetail,
    sithMesPrdShiftHandover,
    sithMesPrdStopWorkType,
    sithMesPrdWorkHourRecord,
    sithMesPrdEhs,
    sithMesPrdOperationUser,
    sithMesPrdProjectInfo,
    sithMesPrdPpOperationSchedulePos,
    sithMesPrdPpOperationDependencyPod,
    sithMesPrdFaultRecord,
    sithMesPrdPpScheduledResultPsr,
    sithMesPrdLearning,
    sithMesPrdOperationStorage,
    sithMesPrdProjectPlanPrp,
    sithMesPrdProjectPlanDetailPpd,
    sithMesProProjectPlanDetailDepPpdd,
    sithMesPrdPdsrRPrpPdrp,
    sithMesPrdManBorrowProcess,
    sithMesPrdPpHeaderInfoModifyType,
    sithMesPrdPpHeaderInfoModify,
    sithMesPrdSdProject,
    sithMesPrdSdProjectActivity,
    sithMesPrdSdProjectNetwork,
    sithMesPrdSdProjectWbs,
    sithMesPrdSdProjectWbsHrc,
    sithMesPrdPpNetwork,
    sithMesPrdPpComponent,
    sithMesSapHandleRecord,
    sithMesPrdPpHeaderInfoModifyOwner,
    sithMesPrdPpdScheduledResultItemPsri,
    sithMesPrdToolsInfo,
    sithMesPrdToolsPackage,
    sithMesPrdToolsPackageItem,
    sithMesPrdToolsRelateOperation,
    sithMesPrdProjectKam,
    sithMesPrdRoutingMaintain,
    sithMesPrdKamChange,
    sithMesPrdInfoRecord,
    sithMesPrdProjectProfitCenter,
    sithMesPrdZpp1,
    sithMesPrdZpp2,
    sithMesPrdZpp2MaterialsDetail
}

export {genericEntities}

export default entities